import { Dayjs } from "dayjs"
import {
  IWarrantsAccount,
  WarrantsAccountDeletedBy,
  WarrantsAccountState,
} from "@/models/admin/warrantsAccount/warrantsAccount.types"
import { sentenceCase } from "@/helpers/stringHelpers"

export class WarrantsAccount implements IWarrantsAccount {
  constructor(
    public id: number,
    public accountNumber: string,
    public status: WarrantsAccountState,
    public pauseStart: Dayjs | null,
    public createdAt: Dayjs,
    public deletedAt: Dayjs | null,
    public deletedByAgentEmail: string | null,
  ) {}

  get isPaused(): boolean {
    return this.pauseStart !== null
  }

  get deletedBy(): WarrantsAccountDeletedBy {
    if (this.deletedAt !== null) return WarrantsAccountDeletedBy.SYSTEM
    if (this.deletedByAgentEmail !== null) return WarrantsAccountDeletedBy.AGENT
    return WarrantsAccountDeletedBy.NONE
  }

  get isDeleted(): boolean {
    return this.deletedBy !== WarrantsAccountDeletedBy.NONE
  }

  get statusDisplay(): string {
    return sentenceCase(this.status)
  }
}
